function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.767,
    height: 9.763,
    viewBox: "0 0 14.767 9.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Expand -Collapse-Accordian"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Back Button"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 5.977 7.357L11.953 0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fillRule: "evenodd"
    },
    transform: "rotate(180 6.68 4.178)",
    "data-name": "icons/d/Down-arrow-16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionIcon);
export default __webpack_public_path__ + "static/media/AccordionIcon.e1c20a360b7e23d5649ce3f756dedc98.svg";
export { ForwardRef as ReactComponent };